import { createFileRoute } from '@tanstack/react-router';
import { PageContainer } from '@/components/shared/PageContainer';
import { queryClient } from '@/lib/utils/queryClient';
import { CategoryFieldsTable } from '../../../-components/CategoryFieldsTable';
import { DeleteCategoryFieldDialog } from '../../../-components/DeleteCategoryFieldDialog';
import { EditCategoryFieldSheet } from '../../../-components/EditCategoryFieldSheet';
import { adminCategoryFieldsQueryOptions } from '../../../-hooks/useAdminCategoryFields';
import { useCategoryFieldsPage } from '../../../-hooks/useCategoryFieldsPage';

/**
 * One category's fields, drilled into from the list.
 *
 * A separate route rather than a tab, because that is what the old dashboard
 * had (`/management/product-categories/:id/fields`) and because the fields
 * belong to one category rather than sitting alongside the list.
 */
export const Route = createFileRoute(
  '/management/product-categories/(pages)/$categoryId/fields/',
)({
  loader: ({ params }) =>
    queryClient
      .ensureQueryData(adminCategoryFieldsQueryOptions(params.categoryId))
      .catch(() => undefined),
  component: CategoryFieldsPage,
});

function CategoryFieldsPage() {
  const { categoryId } = Route.useParams();
  const page = useCategoryFieldsPage(categoryId);

  return (
    <PageContainer>
      <CategoryFieldsTable page={page} />
      <EditCategoryFieldSheet page={page} />
      <DeleteCategoryFieldDialog
        field={page.pendingDeletion}
        onOpenChange={open => !open && page.clearDeletion()}
        onConfirm={() => void page.confirmDeletion()}
        isPending={page.isPending}
      />
    </PageContainer>
  );
}
